<template>
  <div @change="validateSection">
    <header>
      <h3>MIGS Information</h3>
    </header>

    <div class="content">
      <div class="form__row--x">
        <label>Is the MIGS Surgeon any of the following?</label>
        <smd-segment
            type="pill"
            v-model="MIGSSurgeon"
            :items="$options.MIGSChoices"
            :disabled="isClosed"
        />

        <div v-if="MIGSSurgeon === 1" class="form__row">
          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="MIGSSurgeonPSGE"
                :disabled="isClosed"
            />
            PSGE Fellow
          </label>
          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="MIGSSurgeonPSRM"
                :disabled="isClosed"
            />
            PSRM Fellow
          </label>
        </div>
      </div>

      <div>
        <label>Is the MIGS Assist/s any of the following?</label>
        <smd-segment
            type="pill"
            v-model="MIGSAssist"
            :items="$options.MIGSChoices"
            :disabled="isClosed"
        />

        <div v-if="MIGSAssist === 1" class="form__row">
          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="MIGSAssistPSGE"
                :disabled="isClosed"
            />
            PSGE Fellow
          </label>
          <label class="checkbox-label">
            <input
                type="checkbox"
                v-model="MIGSAssistPSRM"
                :disabled="isClosed"
            />
            PSRM Fellow
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import {
  GETTER_CASE_FORM_STATE_FIELD,
  SETTER_CASE_FORM_STATE_FIELD,
} from '../../../store/forms/case-form-state'
import withSectionValidation from '../../../mixins/with-section-validation'
import withErrorValidation from '../../../mixins/with-error-validation-mixin'
import validations from "@/validations/migsinformation-section-validations";

const { mapFields } = createHelpers({
  getterType: GETTER_CASE_FORM_STATE_FIELD,
  mutationType: SETTER_CASE_FORM_STATE_FIELD,
})

export default {
  mixins: [withSectionValidation, withErrorValidation],
  props: {
    isClosed: Boolean,
  },
  computed: {
    ...mapFields([
      'MIGSSurgeon',
      'MIGSSurgeonPSGE',
      'MIGSSurgeonPSRM',
      'MIGSAssist',
      'MIGSAssistPSGE',
      'MIGSAssistPSRM',
    ]),
  },
  validationSection: 'migsInfo',
  MIGSChoices: [
    { id: 1, name: 'FELLOW', val: 1 },
    { id: 2, name: 'NO', val: 2 },
    { id: 3, name: 'N/A', val: 3 },
  ],
  watch: {
    MIGSSurgeon(newVal) {
      if (newVal !== 1) {
        this.MIGSSurgeonPSGE = null
        this.MIGSSurgeonPSRM = null
      }
    },
    MIGSAssist(newVal) {
      if (newVal !== 1) {
        this.MIGSAssistPSGE = null
        this.MIGSAssistPSRM = null
      }
    },
  },
  validations
}
</script>

<style scoped>
.form__row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
}

.form__row--x {
  margin-bottom: 1.5rem;
}
</style>